import { QueryResultCallback } from "../../models/Callback/Callback";
import { Organization } from "../../models/Organization/Organization";
import { TFullOrganizationAttr, TOrganizationAttr, TOrgMemberAttr } from "../../models/Organization/Types";

import { OrgStoreActions } from "../../redux/services/organizations/actions";
import { APIManager } from "../APIManager";
import { OrgNetworkHelper } from "./NetworkHelper";

export class OrgManager {
    networkHelper = OrgNetworkHelper;
    static newOrgObj(data: TOrganizationAttr) {
        return new Organization(data);
    }
    getUserOrg(orgId: string) {
        return OrgStoreActions.getOrganizations().find((t) => t.id === orgId);
    }
    static getActiveOrg() {
        return OrgStoreActions.getActiveOrg();
    }
    saveUserOrganizations(orgs: TOrganizationAttr[]) {
        OrgStoreActions.saveOrganizations(orgs.map((t) => OrgManager.newOrgObj(t)));
    }
    async apiFetchOrgMembers(org: Organization, cb: QueryResultCallback<TOrgMemberAttr[]>) {
        try {
            const resp = await APIManager.get(APIManager.ORG.MEMBERS_API(org.id));
            console.log("MEMBERS 1 => ", resp.data);
            org.updateMembers(resp.data);
            cb(null, resp.data);
        } catch (err) {
            cb(`${err}`);
        }
    }
    async apiUpdateOrgBasicInfo(orgId: string, orgInfo: { name: string }, cb: QueryResultCallback<TOrganizationAttr>) {
        try {
            const resp = await APIManager.put(APIManager.ORG.BASIC_INFO_API(orgId), orgInfo);
            cb(null, resp.data);
        } catch (err) {
            cb(`${err}`);
        }
    }
    async apiFetchAllOrgInfo(orgId: string, cb: QueryResultCallback<TFullOrganizationAttr>) {
        try {
            const allOrgAttrs = await APIManager.get(APIManager.ORG.ALL_INFO_API(orgId));
            cb(null, allOrgAttrs.data);
        } catch (err) {
            cb(`${err}`);
        }
    }

    getCurrentActiveOrg() {
        return OrgStoreActions.getActiveOrg();
    }
    getPersistedActiveOrg() {
        const savedOrgId = OrgStoreActions.getSavedOrgId();
        if (savedOrgId) {
            return OrgStoreActions.getOrganizations().find((t) => t.id === savedOrgId);
        }
        return null;
    }
    getUserOrgs() {
        return OrgStoreActions.getOrganizations();
    }
}
